export default "__VITE_ASSET__BiPQZEqW__"